

import { Link } from 'react-router-dom';
 const ProductCard = ({data}) => {
    
    return ( 
        <Link className='group block overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg' to ={`/product/${data.id}`}>
            <div className="h-72 bg-slate-50 p-6"><img className='h-full w-full object-contain transition duration-300 group-hover:scale-105' src={data.image} alt={data.title} /></div>
              <div className='border-t border-slate-100 p-4'>
                 <h3 className='line-clamp-2 min-h-10 text-sm font-semibold text-slate-800'>{data.title}</h3>
              <div className='mt-3 flex items-center justify-between gap-3'>
                <p className='truncate text-xs capitalize text-slate-500'>{data.category}</p>
                <p className='shrink-0 text-sm font-bold text-slate-900'>${data.price}</p>
              </div></div>
        </Link>
     );
 }
  
 export default ProductCard;
